<template>
  <header
    id="header"
    class="
      flex flex-nowrap justify-center fixed w-full bg-transparent p-3
      pt-5 z-500 text-xl lg:text-2xl font-heading
    "
    :class="{ 'font-medium':isArticulo||isProyecto, 'font-light':!(isArticulo||isProyecto),
              'bg-white': scrollD && !isEncuentro && !isMovil, 
              'bg-azulOscuro': scrollD && isEncuentro2022 && !isMovil, 
              'bg-black': scrollD && isEncuentro2026 && !isMovil, 
              'bg-grisEncuentro': scrollD && isEncuentro2024 && !isMovil }"
  >
    <nav 
      v-if="!isMovil"
      class="flex flex-nowrap justify-between w-10/12 max-w-screen-lg whitespace-nowrap 
      md:w-fit "
    >
      <base-menu 
        :links="navLinks" 
        mode="pc-mode flex flex-nowrap justify-between w-full items-center "
        :class="color"
        :color1="isHome"
        :links-mode="linksMode"
        @close-menu="clickMenu(link)"
      >
      </base-menu>      
    </nav>
  </header>
</template>

<script>

import visibilityHandle from '@/mixins/visibilityHandle.js';
import isPage from '@/mixins/isPageMixin.js';

export default {
  mixins: [visibilityHandle, isPage], 
  props: {
  },
  data() {
    return {
      headerHeight: 42.5,  
    }
  },
  computed: {
    scrollD() {
      return this.$store.getters.getScrollD;
    }, 
    navLinks() {
      if (this.isEncuentro2022) {
        return this.$store.getters.getLinks('encuentro2022');   
      } else if (this.isEncuentro2024) {
        return this.$store.getters.getLinks('encuentro2024');      
      } else if (this.isEncuentro2026) {
        return this.$store.getters.getLinks('encuentro2026');   
      } else if (this.isProyecto || this.isArticulo || this.isRecreacion) {
        return this.$store.getters.getLinks('proyecto');  
      } else if (this.isNovedad){
        return this.$store.getters.getLinks('novedades');  
      } else {
        return this.$store.getters.getLinks('home');
      }
    },
    color() {
      if (this.isEncuentro2022) {
        return "text-amarillo active:text-amarillo "
      } else if (this.isEncuentro2024) {
        return "text-azulOscuro active:text-azulOscuro font-semibold ";
      } else if (this.isEncuentro2026) {
        return "text-naranjaencuentro active:text-naranjaamarillo font-semibold ";
      } else if  (this.isProyecto || this.isArticulo  || this.isNovedad ){
        return "text-amarillo active:text-amarillo ";
      } else {
        return "text-naranja active:text-naranja ";
      }      
    },
    linksMode() {
      if (this.isEncuentro) {
        return "hover:text-naranja flex-row-nowrap justify-start uppercase";
      } else {
        return "hover:text-azul flex-row-nowrap justify-start uppercase ";
      } 
    }, 
  },
  mounted() {
    window.addEventListener('scroll', this.checkScrollDown);
    //console.log(this.$route.path.includes("/proyectos/"));
  },
  methods: {
    checkScrollDown() {
      let scrollparam = this.scrollD;
      if (scrollY > this.headerHeight*0.2)
        scrollparam = true
      else if (scrollY <= this.headerHeight*0.2)
        scrollparam = false

      this.$store.dispatch("changeScroll",{ scroll: scrollparam })
    },
    clickMenu(link){
      //console.log('click menu');
      console.log(link);
    }
  } 

};
</script>

<style>
  .pc-mode .nav-item {
    padding: 0 1rem;
    color: inherit;
  }

  .pc-mode .nav-sub-item {
    padding: 5px 0;
    white-space: nowrap;
  }

  @media screen and (min-width:900px) {
    .pc-mode .nav-item {
    padding: 0 1.5rem;
  }
  }
</style>